export default "__VITE_ASSET__a0NXs9Wd__"